export default __webpack_public_path__ + "static/media/no_image_placeholder.8d8ded09.svg";